"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useScrollTo;

var _react = require("react");

var _useWebChatUIContext2 = _interopRequireDefault(require("./internal/useWebChatUIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useScrollTo() {
  var _useWebChatUIContext = (0, _useWebChatUIContext2.default)(),
      scrollToCallbacksRef = _useWebChatUIContext.scrollToCallbacksRef;

  return (0, _react.useCallback)(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return scrollToCallbacksRef.current.forEach(function (callback) {
      return callback.apply(void 0, args);
    });
  }, [scrollToCallbacksRef]);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VTY3JvbGxUby50cyJdLCJuYW1lcyI6WyJ1c2VTY3JvbGxUbyIsInNjcm9sbFRvQ2FsbGJhY2tzUmVmIiwiYXJncyIsImN1cnJlbnQiLCJmb3JFYWNoIiwiY2FsbGJhY2siXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7QUFHQTs7OztBQUVlLFNBQVNBLFdBQVQsR0FHTDtBQUNSLDZCQUFpQyxvQ0FBakM7QUFBQSxNQUFRQyxvQkFBUix3QkFBUUEsb0JBQVI7O0FBRUEsU0FBTyx3QkFBWTtBQUFBLHNDQUFJQyxJQUFKO0FBQUlBLE1BQUFBLElBQUo7QUFBQTs7QUFBQSxXQUFhRCxvQkFBb0IsQ0FBQ0UsT0FBckIsQ0FBNkJDLE9BQTdCLENBQXFDLFVBQUFDLFFBQVE7QUFBQSxhQUFJQSxRQUFRLE1BQVIsU0FBWUgsSUFBWixDQUFKO0FBQUEsS0FBN0MsQ0FBYjtBQUFBLEdBQVosRUFBOEYsQ0FDbkdELG9CQURtRyxDQUE5RixDQUFQO0FBR0QiLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IHVzZUNhbGxiYWNrIH0gZnJvbSAncmVhY3QnO1xuXG5pbXBvcnQgU2Nyb2xsUG9zaXRpb24gZnJvbSAnLi4vdHlwZXMvU2Nyb2xsUG9zaXRpb24nO1xuaW1wb3J0IHVzZVdlYkNoYXRVSUNvbnRleHQgZnJvbSAnLi9pbnRlcm5hbC91c2VXZWJDaGF0VUlDb250ZXh0JztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXNlU2Nyb2xsVG8oKTogKFxuICBwb3NpdGlvbjogU2Nyb2xsUG9zaXRpb24sXG4gIHNjcm9sbFRvT3B0aW9uczogeyBiZWhhdmlvcj86ICdhdXRvJyB8ICdzbW9vdGgnIH1cbikgPT4gdm9pZCB7XG4gIGNvbnN0IHsgc2Nyb2xsVG9DYWxsYmFja3NSZWYgfSA9IHVzZVdlYkNoYXRVSUNvbnRleHQoKTtcblxuICByZXR1cm4gdXNlQ2FsbGJhY2soKC4uLmFyZ3MpID0+IHNjcm9sbFRvQ2FsbGJhY2tzUmVmLmN1cnJlbnQuZm9yRWFjaChjYWxsYmFjayA9PiBjYWxsYmFjayguLi5hcmdzKSksIFtcbiAgICBzY3JvbGxUb0NhbGxiYWNrc1JlZlxuICBdKTtcbn1cbiJdfQ==